import React from "react"
import PropTypes from "prop-types"

import avatar from "../images/avatar.svg"
import styles from "../styles/components/avatar.module.scss"

export default function Avatar({ image, variant }) {
  return (
    <div
      className={
        variant === "sm" ? styles.sm : variant === "xs" ? styles.xs : styles.img
      }
    >
      <img src={image} alt="Profile Image" />
    </div>
  )
}

Avatar.propTypes = {
  image: PropTypes.string,
  variant: PropTypes.string,
}

Avatar.defaultProps = {
  image: avatar,
  variant: "lg",
}
